import type { Map } from 'immutable';

import { selector } from '@/lib/selectors';
import type { LocationRecord, Query, RoutingState } from '@/domain/router/types';

export const routing = (state) => state.routing;
export const locationSelector = selector<unknown, LocationRecord>(routing, (r: RoutingState) => r.get('location'));
export const locationKeySelector = selector<unknown, string>(routing, (r: RoutingState) =>
  r.getIn(['location', 'key']),
);
export const searchSelector = selector<unknown, string>(locationSelector, (l: LocationRecord) => l.get('search'));
export const querySelector = selector<unknown, Query>(locationSelector, (l: LocationRecord) => l.query);
export const stateSelector = selector<unknown, Map<string, unknown>>(locationSelector, (l: LocationRecord) =>
  l.get('state'),
);
export const backUrlSelector = selector(stateSelector, (s: Map<string, unknown>) => s.get('backUrl'));
export const prevLocationSelector = selector<unknown, LocationRecord>(routing, (r: RoutingState) =>
  r.get('prevLocation'),
);
export const routerCompleteHashSelector = selector<unknown, string | null>(routing, (r: RoutingState) => r.complete);
export const prevQuerySelector = selector<unknown, Query>(prevLocationSelector, (l: LocationRecord) => l.query);

export const locationIsChange = selector<unknown, boolean>(
  prevLocationSelector,
  locationSelector,
  (prev: LocationRecord, current: LocationRecord) => {
    if (prev.pathname !== current.pathname) return true;
    // think of using key === default
    return prev.search !== current.search || prev.key !== current.key;
  },
);
